/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import { connect } from 'react-redux';
import {List} from 'immutable';
import {getNameByLang} from '../../common/lib/util';

//actions
import { setCategory } from '../../common/categories/actions';

class Products extends React.Component {

    state: State = {
        page: 0
    };

    static propTypes = {
        sectionId: React.PropTypes.string,
        sectionClass: React.PropTypes.string,
        selectProduct: React.PropTypes.func.isRequired,
        categories: React.PropTypes.object,
        setCategory: React.PropTypes.func,
        selectedCategoryId: React.PropTypes.number,
        offerId: React.PropTypes.number,
        maxButtons: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.goHome = this.goHome.bind(this);
        this.selectCategory = this.selectCategory.bind(this);
        this.selectProduct = this.selectProduct.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.getCategories = this.getCategories.bind(this);
        this.countPages = this.countPages.bind(this);
    }

    goHome() {
        this.selectCategory(0);
    }

    nextPage(numPages) {
        const {page} = this.state;
        if (numPages === page) {
            this.setState({page: 0});
        } else {
            this.setState({page: page + 1});
        }
    }

    selectCategory(categoryId) {
        const {setCategory} = this.props;
        this.setState({page: 0});
        setCategory(categoryId);
    }

    selectProduct(p) {
        const {selectProduct} = this.props;
        selectProduct(p)
    }

    componentWillMount() {
        this.goHome();
    }

    componentWillReceiveProps(nextProps) {
        const {selectedCategoryId} = this.props;
        const {selectedCategoryId: nextId} = nextProps;

        if (selectedCategoryId !== nextId) {
            this.setState({page: 0});
        }
    }

    countPages(categoryItems) {
        const {selectedCategoryId, maxButtons, categories} = this.props;
        if (selectedCategoryId > 0) {
            if (categoryItems.size > (maxButtons - 1)) {
                return parseInt(categoryItems.size / (maxButtons - 1));
            }
        } else {
            const size = categoryItems.size + categories.size;
            if (size > (maxButtons - 1)) {
                return parseInt(size / (maxButtons - 1));
            }
        }
        return 0;
    }

    getCategoryItems(categories, selectedCategoryId, offerId) {
        const cats = categories.filter(c => c.get('id') === selectedCategoryId && offerId === c.get('offerId'));
        const category = cats.size > 0
            ? cats.first()
            : null;
        return !!category ? category.get('items').filter(i => !!i.get('active')) : List();
    }

    getCategories() {
        const {categories} = this.props;
        return categories.filter(c => c.get('active'));
    }

    render() {
        const {selectedCategoryId, maxButtons, sectionClass, sectionId, offerId} = this.props;
        const {page} = this.state;

        const categories = this.getCategories();
        const categoryItems = this.getCategoryItems(categories, selectedCategoryId, offerId);
        const numPages = this.countPages(categoryItems);

        let buttonsLeft = maxButtons;
        let items = List();
        let categoriesToRender = List();
        let buttonsLeftList = List();

        //krátíme kvůli home
        if (selectedCategoryId > 0) {
            buttonsLeft -= 1;
        }
        //krátíme kvůli stránkování
        if (numPages > 0) {
            buttonsLeft -= 1;
        }

        const from = page * buttonsLeft;
        const to = from + buttonsLeft;
        let categoriesSize = 0;
        const categoriesWithoutNonCategory = categories.filter(c => c.get('id') );

        if (selectedCategoryId === 0) {
            categoriesWithoutNonCategory.forEach((cat, i) => {
                if (i >= from && i < to) {
                    categoriesSize++;
                    categoriesToRender = categoriesToRender.push(cat);
                }
            });
            buttonsLeft -= categoriesToRender.size;
        }
        categoryItems.forEach((item, i) => {
            let catSize = 0;
            if (selectedCategoryId === 0) {
                catSize = categoriesWithoutNonCategory.size;
            }
            if (i + catSize >= from && i + catSize < to) {
                items = items.push(item);
            }
        });
        buttonsLeft -= items.size;

        for (let i = 0; i < buttonsLeft; i++) {
            buttonsLeftList = buttonsLeftList.push(i);
        }

        return (
            <section id={`${!!sectionId ? sectionId : 'products'}`}
                     className={`productList ${!!sectionClass ? sectionClass : 'products-grid'}`}>
                {selectedCategoryId > 0 &&
                    <div className="productList-box">
                      <div className="boxBtn color-greenLight control"
                           onClick={() => this.goHome()}>
                          <div className="boxBtn-inner">
                            <svg className={`shape shape-home`}>
                              <use xlinkHref={`#shape-home`}></use>
                            </svg>
                          </div>
                      </div>
                    </div>
                }
                {selectedCategoryId === 0 && categoriesToRender.map((cat, i) =>
                  <div key={`category-cat-${i}`} className="productList-box">
                    <div className="boxBtn color-green category"
                         onClick={() => this.selectCategory(cat.get('id'))}>
                        <div className="boxBtn-inner"
                             style={{backgroundColor: cat.getIn(['color', 'backgroundColor']), color: cat.getIn(['color', 'textColor'])}}>
                            <span>
                                {getNameByLang(cat)}
                            </span>
                        </div>
                    </div>
                  </div>
                )}
                {items.map((item, i) =>
                  <div className="productList-box" key={`category-item-${i}`}>
                    <div className="boxBtn color-white item"
                         onClick={() => this.selectProduct(item.get('id'))}>
                        <div className="boxBtn-inner"
                             style={{backgroundColor: item.getIn(['color', 'backgroundColor']), color: item.getIn(['color', 'textColor'])}}>
                            <span>
                                {getNameByLang(item)}
                            </span>
                        </div>
                    </div>
                  </div>
                )}

                {buttonsLeftList.map((ent, i) =>
                  <div className="productList-box" key={`category-void-${i}`}>
                    <div className="boxBtn"/>
                  </div>
                )}

                {numPages > 0 &&
                <div className="productList-box" key={`category-next`}>
                    <div onClick={() => this.nextPage(numPages)}
                         className="boxBtn color-greenLight control">
                        <div className="boxBtn-inner">
                            <span>
                               &rarr;
                            </span>
                        </div>
                    </div>
                </div>
                }
            </section>
        );
    }
}

export default connect(state => ({
    categories: state.categories.get('choosedOfferCategories'),
    selectedCategoryId: state.categories.get('selectedCategoryId'),
    offerId: state.categories.get('offerId')
}), { setCategory })(Products);



// WEBPACK FOOTER //
// ./src/browser/home/Products.js